import type { IEnvConfig } from "@adgm/cross-models";

const apikeyBugsnagProd = "39c2a22c6792caf8a4ca4317e3e9d273";
const OSSURL = "https://aspen-prod.oss-ap-southeast-1.aliyuncs.com";
const staticHost = "https://static.aspendigital.co";
const prod: IEnvConfig = {
  env: "prod",
  host: "https://api-ad.aspendigital.co/",
  websocket: {
    host: "wss://ws-ad.aspendigital.co:8080",
  },
  googlePlayUrl: "https://play.google.com/store/apps/details?id=com.aspendigital.adgm", // google play中下载地址
  appStoreUrl: "https://apps.apple.com/app/id6743303741", // appStore中下载地址
  ossUrl: OSSURL, //策略图片oss地址
  appDomain: "https://apponly-ad.aspendigital.co",
  webDomain: "https://portal-ad.aspendigital.co",
  domainUriPrefix: "https://adgm.onelink.me/6j3b",
  staticHost,
  fallbackUrl: {
    android: "https://play.google.com/store/apps/details?id=com.aspendigital.adgm",
    ios: "https://apps.apple.com/app/id6743303741",
  },
  packageName: {
    android: "com.aspendigital.adgm",
    ios: "com.aspendigital.adgm",
  },

  klineChartUrl: "",
  tvChartUrl: "https://tradingview-ad.aspendigital.co/",
  apiKeyBugsnag: apikeyBugsnagProd,
  minimumVersion: {
    android: "",
    ios: "",
  },
  operationServer: "https://api-aoperation-ad.aspendigital.co",
  saasServer: "",
  appScheme: "ADGM",
  universalDownloadLink: "https://adgm.onelink.me/6j3b/pv8z2eww",
  aiChatUrl: "https://adgm-ai.vercel.app/app",
};

export default prod;
